import React from 'react';
import { Medal } from 'lucide-react';

const TIER_COLORS = {
  Bronze: 'text-amber-700', Silver: 'text-neutral-500', Gold: 'text-yellow-600',
};

export const PartnerTier = ({ tier, isEs }) => {
  if (!tier) return null;
  const pct = Math.min(tier.progress_pct ?? 0, 100);
  return (
    <div className="mt-6 rounded-2xl border border-neutral-200 bg-white p-5" data-testid="aff-tier">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="flex items-center gap-2 text-[11px] uppercase tracking-wider text-neutral-500 font-bold">
          <Medal className={`w-4 h-4 ${TIER_COLORS[tier.tier_name] || 'text-[#F77F11]'}`} />
          {isEs ? 'Tu nivel de partner' : 'Your partner tier'}
        </p>
        <p className="text-[12px] text-neutral-500">
          Bronze 30% · Silver 35% <span className="text-neutral-400">(3+ {isEs ? 'clientes' : 'customers'})</span> · Gold 40% <span className="text-neutral-400">(10+)</span>
        </p>
      </div>
      <div className="mt-3 flex flex-wrap items-center gap-4">
        <p className={`text-2xl font-bold ${TIER_COLORS[tier.tier_name] || 'text-neutral-900'}`} data-testid="aff-tier-name">{tier.tier_name}</p>
        <p className="text-[13px] text-neutral-600">
          {isEs ? 'Comisión actual' : 'Current commission'}: <b className="text-[#F77F11]">{Math.round(tier.rate * 100)}%</b> {isEs ? 'recurrente' : 'recurring'}
        </p>
      </div>
      {tier.next_tier && (
        <div className="mt-3">
          <div className="flex justify-between text-[11.5px] text-neutral-500 mb-1">
            <span>{tier.customers} {isEs ? 'cliente(s)' : 'customer(s)'}</span>
            <span data-testid="aff-tier-next">
              {isEs ? `${tier.to_next} más para ${tier.next_tier} (${Math.round(tier.next_rate * 100)}%)` : `${tier.to_next} more to ${tier.next_tier} (${Math.round(tier.next_rate * 100)}%)`}
            </span>
          </div>
          <div className="h-2 rounded-full bg-neutral-100 overflow-hidden">
            <div className="h-full rounded-full bg-gradient-to-r from-[#F77F11] to-[#FF9B4A]" style={{ width: `${pct}%`, transition: 'width 1s ease' }} />
          </div>
          {tier.est_increase_monthly > 0 && (
            <p className="mt-2 text-[12.5px] font-semibold text-emerald-600" data-testid="aff-tier-estimate">
              {isEs
                ? `Incremento recurrente estimado al subir: +$${tier.est_increase_monthly}/mes 🚀`
                : `Estimated recurring increase when you level up: +$${tier.est_increase_monthly}/month 🚀`}
            </p>
          )}
        </div>
      )}
    </div>
  );
};
